function updateCurrentDateElements() {
    const now = new Date();

    // Full date format: "September 21, 2025"
    const fullDate = now.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    // Year only: "2025"
    const year = now.getFullYear();

    // Update all .current-date elements
    document.querySelectorAll('.current-date').forEach(el => {
        el.textContent = fullDate;
    });

    // Update all .current-year elements
    document.querySelectorAll('.current-year').forEach(el => {
        el.textContent = year;
    });
}

// Run once on page load
updateCurrentDateElements();